import { get } from 'lodash';

export const safeGet = (...params: Parameters<typeof get>) => {
  const [object, path, defaultValue] = params;
  const result = get(object, path, defaultValue);
  // We want to return the `defaultValue` even if the value is `null`
  // By default, `get` will return `null` instead of the `defaultValue`
  return result === null ? defaultValue : result;
};
